
export function getGlobalJsData() {
    return window.jsdata ?? {};
}

export function getDefaultUiLocale() {
    return getGlobalJsData().uiText?.locale ?? '';
}

export function getUiText(form, key, defaultValue) {
    const uiText = getGlobalJsData().uiText?.[form] ?? {};
    return uiText[key] ?? defaultValue;
}
